import { NOOP } from '@vue/shared'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { useSizeProp } from '@sgui-plus/hooks'

import { useTooltipContentProps } from '@sgui-plus/components/tooltip'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'

import type { ExtractPropTypes } from 'vue'
import type Autocomplete from './index.vue'
import type { Placement } from '@sgui-plus/components/popper'

export type Awaitable<T> = Promise<T> | T
export type AutocompleteData = Record<string, any>[]
export type AutocompleteFetchSuggestionsCallback = (
  data: AutocompleteData
) => void
export type AutocompleteFetchSuggestions =
  | ((
      queryString: string,
      cb: AutocompleteFetchSuggestionsCallback
    ) => Awaitable<AutocompleteData> | void)
  | AutocompleteData

export const autocompleteProps = {
  transfer: useTooltipContentProps.transfer,
  ...buildProps({
    valueKey: {
      type: String,
      default: 'value',
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    debounce: {
      type: Number,
      default: 300,
    },
    placement: {
      type: definePropType<Placement>(String),
      values: [
        'top',
        'top-start',
        'top-end',
        'bottom',
        'bottom-start',
        'bottom-end',
      ],
      default: 'bottom-start',
    },
    fetchSuggestions: {
      type: definePropType<AutocompleteFetchSuggestions>([Function, Array]),
      // type: Function as definePropType<(queryString: string, cb: (data: any[]) => void) => void>,
      default: NOOP,
    },
    triggerOnFocus: {
      type: Boolean,
      default: true,
    },
    selectWhenUnmatched: {
      type: Boolean,
      default: false,
    },
    hideLoading: {
      type: Boolean,
      default: false,
    },
    highlightFirstItem: {
      type: Boolean,
      default: false,
    },
    scrollwidth: String,
    scrollheight: {
      type: String,
      default: '280px'
    },
    size: useSizeProp,
  } as const),
}as const
export type AutocompleteProps = ExtractPropTypes<typeof autocompleteProps>

export const autocompleteEmits = [
    UPDATE_MODEL_EVENT,
    'onInput',
    'onChange',
    'onFocus',
    'onBlur',
    'onClear',
    'onSelect',
  ]


export type AutocompleteEmits = typeof autocompleteEmits

export type AutocompleteInstance = InstanceType<typeof Autocomplete>
